import type { FunctionComponent } from "react";
import type { IProps } from "./stepped-modal-footer.types";
import { Modal } from "../../modal";

/**
 * Consumer-owned footer for the base SteppedModal. Renders inside the modal footer with
 * right-aligned actions.
 */
const SteppedModalFooter: FunctionComponent<IProps> = ({ children }) => {
    return (
        <Modal.Footer>
            <Modal.Footer.Actions>{children}</Modal.Footer.Actions>
        </Modal.Footer>
    );
};

export { SteppedModalFooter };
